/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import {
    IBuyboxAddToCartViewProps,
    IBuyboxAddToOrderTemplateViewProps,
    IBuyboxAddToWishlistViewProps,
    IBuyboxCallbacks,
    IBuyboxData,
    IBuyboxFindInStoreViewProps,
    IBuyboxKeyInPriceViewProps,
    IBuyboxProductConfigureDropdownViewProps,
    IBuyboxProductConfigureViewProps,
    IBuyboxProductQuantityViewProps,
    IBuyboxProps,
    IBuyboxShopSimilarLookViewProps,
    IBuyboxState,
    // IBuyboxViewProps
} from '@msdyn365-commerce-modules/buybox';
import {
    IModuleProps,
    IncrementalQuantity,
    INodeProps,
    ITelemetryContent, Modal, ModalBody, ModalFooter, ModalHeader,
    Module,
    Node
} from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import {
    IBuyboxProps as IBuyboxExtentionProps,
    IBuyboxResources as IBuyboxExtentionResources
} from '../definition-extensions/buybox.ext.props.autogenerated';
import {ProductCatalog} from "@msdyn365-commerce/retail-proxy";
export interface IBuyboxViewProps extends IBuyboxProps<IBuyboxData> {
    state: IBuyboxState;
    ModuleProps: IModuleProps;
    ProductInfoContainerProps: INodeProps;
    MediaGalleryContainerProps: INodeProps;
    callbacks: IBuyboxCallbacks;
    mediaGallery?: React.ReactNode;
    title?: React.ReactNode;
    description?: React.ReactNode;
    rating?: React.ReactNode;
    price?: React.ReactNode;
    productComparisonButton?: React.ReactNode;
    bulkPurchaseLink?: React.ReactNode;
    addToOrderTemplate?: IBuyboxAddToOrderTemplateViewProps;
    addToWishlist?: IBuyboxAddToWishlistViewProps;
    max: number | undefined;
    addToCart: IBuyboxAddToCartViewProps;
    findInStore?: IBuyboxFindInStoreViewProps;
    quantity?: IBuyboxProductQuantityViewProps;
    configure?: IBuyboxProductConfigureViewProps;
    inventoryLabel?: React.ReactNode;
    shopSimilarLook?: IBuyboxShopSimilarLookViewProps;
    shopSimilarDescription?: IBuyboxShopSimilarLookViewProps;
    quantityLimitsMessages: React.ReactNode;
    telemetryContent?: ITelemetryContent;
    keyInPrice?: IBuyboxKeyInPriceViewProps;
    unitOfMeasure?: React.ReactNode;
    catalogs?: ProductCatalog[] | undefined;
    isChannelMultipleCatalogsFeatureEnabled?: boolean;
    currentCatalogId?: number;
    isShareModalOpen?:boolean;
    toggleShareModal: () => void;
    prodSpecs: any;
}
const BuyboxView: React.FC<IBuyboxViewProps &
    IBuyboxExtentionProps<IBuyboxData>> = props => {
    // @ts-ignore
    const {
        ModuleProps,
        MediaGalleryContainerProps,
        ProductInfoContainerProps,
        addToCart,
        addToOrderTemplate,
        addToWishlist,
        telemetryContent,
        configure,
        // description,
        findInStore,
        quantity,
        price,
        rating,
        callbacks,
        state,
        resources,
        // inventoryLabel,
        shopSimilarLook,
        keyInPrice,
        quantityLimitsMessages,
        max,
        shopSimilarDescription,
        // unitOfMeasure,
        isShareModalOpen,
        toggleShareModal
    } = props;
    const featuredAttribute = props.prodSpecs &&
        props.prodSpecs.length > 0 && props.prodSpecs.filter((sp: { Name:
                string; }) => {
            return sp.Name?.toLowerCase() === 'featured';
        });
    const featuredAttributeValue = featuredAttribute &&
    featuredAttribute?.[0] ? featuredAttribute[0]?.TextValue?.split('|') :
        [];


    return (
        <Module {...ModuleProps}>

            <Node {...MediaGalleryContainerProps}>{props.mediaGallery}</Node>
            <Node {...ProductInfoContainerProps}>
                {_titleHead(
                    addToWishlist,
                    props.data.product.result?.Name,
                    props.data.product.result?.ProductNumber,
                    toggleShareModal,
                    isShareModalOpen,
                    props.slots && props.slots.socialShare,
                    featuredAttributeValue,
                    props.context,
                )}
                {/*{price}*/}
                {/*{unitOfMeasure}*/}
                {props.bulkPurchaseLink}
                {/*{description}*/}
                {/*{_renderTextBlock(props.slots.textBlocks)}*/}
                {rating}
                {/*{configure && _renderConfigure(configure)}*/}
                {keyInPrice && _renderKeyInPrice(keyInPrice)}
                <div className='row'>
                    <div className='col-md-12 col-6 pdp-price '>
                        <div className='unit'>{configure &&
                            _renderConfigure(configure)}</div>
                        <div className='price'>{price}</div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6 col-6'>
                        {quantity && _renderQuantity(quantity,
                            callbacks, props, state, resources, quantityLimitsMessages, max,
                            telemetryContent)}
                    </div>
                    <div className='col-md-6 col-6'>
                        {_renderCartAndActions(addToCart,
                            addToOrderTemplate,price,configure, props?.state?.productPrice)}
                    </div>
                </div>
                {/*{inventoryLabel}*/}

                {findInStore && _renderFindInStore(findInStore)}
                {shopSimilarLook && _renderShopSimilarItem(shopSimilarLook)}
                {shopSimilarDescription &&
                    _renderShopSimilarItem(shopSimilarDescription)}
            </Node>
        </Module>
    );
};

/*const _renderTextBlock = (textBlocks: React.ReactNode[]):
JSX.Element | undefined => {
    if (!textBlocks || textBlocks.length === 0) {
        return undefined;
    }

    return <>{textBlocks[0]}</>;
};*/
const _renderCartAndActions = (
    addToCart?: IBuyboxAddToCartViewProps,
    addToOrderTemplate?: IBuyboxAddToOrderTemplateViewProps,
    // addToWishlist?: IBuyboxAddToWishlistViewProps,
    price?: any,
    configure?:any,
    productPrice?: any
): JSX.Element | undefined => {
    if (!addToCart) {
        return undefined;
    }
//const percentageOff = productPrice?.DiscountAmount !==
    productPrice?.BasePrice ? Math.floor(productPrice?.DiscountAmount /
        productPrice?.BasePrice * 100) : 0;
    return (
        <div className='product-add-to-cart'>
            {addToCart && addToCart.errorBlock}
            {addToOrderTemplate && addToOrderTemplate.errorBlock}
            {/*{addToWishlist && addToWishlist.errorBlock}*/}
            <div className='buttons custom-add-to-cart-button'>
                {addToCart && addToCart.button}
                {addToOrderTemplate && addToOrderTemplate.button}
                {/*{addToWishlist && addToWishlist.button}*/}
            </div>
        </div>
    );
};

const _titleHead = (
    addToWishlist?: IBuyboxAddToWishlistViewProps,
    name?:string,
    Number?:string,
    toggleShareModal?: () => void,
    isShareModalOpen?:any,
    socialShare?:React.ReactNode[],
    featuredAttributeValue?: [],
    props?:any,
): JSX.Element | undefined => {
    if (!addToWishlist) {
        return undefined;
    }
    let whatspappLink= 'https://wa.me/?text='+props.request.url.requestUrl;
    return (

        <>
            <div className='row pdp-header'>
                <div className='col-md-10 col-8 pdp-heading '>
                    <h2>{name}</h2>
                </div>
                <div className='col-md-1 col-2 pdp-mob-wishlist'>
                    <div className='add-to-wishlist'>
                        {addToWishlist && addToWishlist.errorBlock}
                        <div className='buttons'>
                            {addToWishlist && addToWishlist.button}
                        </div>
                    </div>
                </div>
                <div className='col-md-1 col-2 pdp-mob-wishlist'>
                    <p>
                        <label className="tooltip">
                            <svg width="34" height="34" viewBox="0 0
34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="34" height="34" rx="17"
                                      fill="#F9F8F9"/>
                                <g clip-path="url(#clip0_840_5312)">
                                    <path d="M12.75 19.25C13.9926
19.25 15 18.2426 15 17C15 15.7574 13.9926 14.75 12.75 14.75C11.5074
14.75 10.5 15.7574 10.5 17C10.5 18.2426 11.5074 19.25 12.75 19.25Z"
                                          stroke="#4D4851" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21.25 23.5C22.4926 23.5
23.5 22.4926 23.5 21.25C23.5 20.0074 22.4926 19 21.25 19C20.0074 19 19
20.0074 19 21.25C19 22.4926 20.0074 23.5 21.25 23.5Z" stroke="#4D4851"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21.25 15C22.4926 15 23.5
13.9926 23.5 12.75C23.5 11.5074 22.4926 10.5 21.25 10.5C20.0074 10.5
19 11.5074 19 12.75C19 13.9926 20.0074 15 21.25 15Z" stroke="#4D4851"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M14.7598 16L19.2398
13.75" stroke="#4D4851" stroke-linecap="round"
                                          stroke-linejoin="round"/>
                                    <path d="M14.7598 18L19.2398
20.25" stroke="#4D4851" stroke-linecap="round"
                                          stroke-linejoin="round"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_840_5312">
                                        <rect width="14" height="14"
                                              fill="white" transform="translate(10 10)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <input type="checkbox"/>
                            <span className='whatsapp'>
                                <a href={whatspappLink} target='_blank'>
                                  <img
                                      src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/mhkxmwzwbc/imageFileData/MDg1B?pubver=1'
                                  />
                                </a>
                                {socialShare ? socialShare : [0]}</span>
                        </label>
                    </p>

                </div>
            </div>
            <div className='row product-sub-header'>
                <div className='sku-pdp'>SKU:{Number}</div>

                {featuredAttributeValue && featuredAttributeValue.length > 0 &&
                    (featuredAttributeValue.map((value:any) => {
                            return <><div className='planted-pdp'>
                                <div className='planted-img'>
                                    {value == 'Planted & Produced'?
                                        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="60" height="60" rx="30" fill="#F1E7FD"/>
                                            <circle cx="30" cy="30" r="15" fill="#610FD1"/>
                                         </svg>: null
                                    }
                                    {value == 'Manufactured'?
                                        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="60" height="60" rx="30" fill="#F1E7FD"/>
                                            <path d="M41 30.8904C40.9548 34.1134 39.7565 36.7939 37.6941 39.1626C35.6167 41.5509 32.9615 43.2152 30.3062 44.8868C30.1128 45.0095 29.9571 45.0513 29.741 44.9163C27.1034 43.2545 24.4481 41.6172 22.3883 39.246C18.6328 34.9234 18.0148 30.1982 20.4565 25.0705C21.293 23.3154 22.4084 21.7518 23.7297 20.3158C25.355 18.551 27.0682 16.8818 28.9949 15.4262C29.7486 14.8567 30.2409 14.8567 31.0096 15.4336C33.3257 17.1739 35.3705 19.1892 37.1993 21.4032C39.1486 23.7597 40.4825 26.4107 40.8945 29.4471C40.9623 29.9503 40.9699 30.4633 41 30.8904Z" fill="#610FD1"/>
                                        </svg>
                                        : null
                                    }
                                    {value == 'Packed'?
                                        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="60" height="60" rx="30" fill="#F1E7FD"/>
                                            <g clip-path="url(#clip0_383_448)">
                                                <path d="M30.0242 30.0146C34.8216 30.0146 39.6214 30.0219 44.4188 30.0024C44.9026 30.0024 45.0169 30.1272 44.995 30.6072C44.6789 37.8489 39.3029 43.7779 32.198 44.8309C24.0062 46.0456 16.7919 40.506 15.2941 32.7428C15.1628 32.0668 15.1361 31.3689 15.0242 30.6881C14.9415 30.1762 15.051 29.9975 15.6272 29.9999C20.4246 30.0268 25.2244 30.0146 30.0218 30.0146H30.0242Z" fill="#610FD1"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_383_448">
                                                    <rect width="30" height="15" fill="white" transform="translate(15 30)"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        : null
                                    }
                                </div>
                                <div>{value}</div>
                            </div> </>
                        })
                    )
                }

            </div>
            {/*  <div className='row product-offer'>
                <div className='icon-offer'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24"
height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
d="M22.328 9.23077L23.8607 11.5158C24.0557 11.8224 24.0557 12.1567
23.8607 12.4354L22.328 14.7483L22.4952 17.535C22.5231 17.8415 22.3559
18.1759 22.0493 18.3152L19.5971 19.5692L18.3431 22.0215C18.2038
22.3001 17.8972 22.4952 17.5628 22.4673L14.8041 22.328L12.4911
23.8607C12.3518 23.9443 12.1846 24 12.0174 24C11.8502 24 11.683
23.9443 11.5437 23.8607L9.23077 22.328L6.47199 22.4673C6.16546 22.4952
5.83106 22.328 5.69173 22.0215L4.43774 19.5692L1.98549 18.3152C1.70682
18.148 1.51176 17.8415 1.53962 17.5071L1.67895 14.7483L0.146299
12.4354C-0.0487663 12.1567 -0.0487663 11.7945 0.146299 11.5158L1.67895
9.2029L1.53962 6.44412C1.51176 6.13759 1.67896 5.80319 1.98549
5.66386L4.43774 4.40987L5.69173 1.95762C5.85893 1.67896 6.16546
1.48389 6.49986 1.53962L9.25864 1.67896L11.5437 0.146299C11.8224
-0.0487663 12.1846 -0.0487663 12.4633 0.146299L14.7762 1.67896L17.5628
1.51176C17.8694 1.48389 18.2038 1.65109 18.3431 1.95762L19.5692
4.43774L22.0215 5.69173C22.3001 5.83106 22.4952 6.13759 22.4673
6.47199L22.328 9.23077ZM20.656 14.5811C20.656 14.3861 20.6839 14.2189
20.7954 14.0517L22.1608 11.9617L20.7954 9.89957C20.6839 9.76023 20.656
9.56517 20.656 9.39797L20.6839 6.94572L18.4824 5.83106C18.3431 5.74746
18.2038 5.63599 18.1202 5.4688L17.0055 3.26734L14.5254 3.40668C14.3582
3.40668 14.1631 3.37881 14.0238 3.26734L11.9617 1.90189L9.89957
3.26734C9.76023 3.37881 9.56517 3.40668 9.39797 3.40668L6.91785
3.26734L5.80319 5.4688C5.71959 5.60813 5.60813 5.74746 5.44093
5.83106L3.23948 6.94572L3.37881 9.42583C3.37881 9.59303 3.35094 9.7881
3.23948 9.92743L1.87402 11.9896L3.26734 14.1074C3.37881 14.2467
3.40668 14.4418 3.40668 14.609L3.26734 17.0891L5.4688 18.2038C5.60813
18.2874 5.74746 18.3988 5.83106 18.566L6.94572 20.7675L9.42583
20.6282H9.48157C9.64877 20.6282 9.81596 20.6839 9.9553 20.7675L12.0174
22.1329L14.1074 20.7675C14.2467 20.656 14.4418 20.6282 14.609
20.6282L17.117 20.7396L18.2316 18.5382C18.3152 18.3988 18.4267 18.2595
18.5939 18.1759L20.7954 17.0612L20.656 14.5811ZM11.46 8.78491C11.46
10.4012 10.1502 11.7109 8.53399 11.7109C6.91773 11.7109 5.60801
10.4012 5.60801 8.78491C5.60801 7.16865 6.91773 5.85893 8.53399
5.85893C10.1502 5.85893 11.46 7.16865 11.46 8.78491ZM9.78798
8.78491C9.78798 8.08824 9.23065 7.53091 8.53399 7.53091C7.83733
7.53091 7.28 8.08824 7.28 8.78491C7.28 9.48157 7.83733 10.0389 8.53399
10.0389C9.23065 10.0389 9.78798 9.48157 9.78798 8.78491ZM15.2222
12.5469C13.6059 12.5469 12.2962 13.8566 12.2962 15.4729C12.2962
17.0891 13.6059 18.3988 15.2222 18.3988C16.8384 18.3988 18.1482
17.0891 18.1482 15.4729C18.1482 13.8566 16.8384 12.5469 15.2222
12.5469ZM15.2222 16.7268C14.5255 16.7268 13.9682 16.1695 13.9682
15.4729C13.9682 14.7762 14.5255 14.2189 15.2222 14.2189C15.9188
14.2189 16.4762 14.7762 16.4762 15.4729C16.4762 16.1695 15.9188
16.7268 15.2222 16.7268ZM16.1974 6.63919C16.504 6.30479 17.0334
6.30479 17.3678 6.63919C17.7022 6.97359 17.7022 7.47518 17.3678
7.80958L7.8375 17.3399C7.6703 17.5071 7.44737 17.5907 7.2523
17.5907C7.05724 17.5907 6.83431 17.5071 6.66711 17.3399C6.33271
17.0334 6.33271 16.5039 6.66711 16.1695L16.1974 6.63919Z"
fill="#935B06"/>
                     </svg>
                </div>
                <div className='offer-text'>Order 3 items together and
get 15% extra discount</div>
            </div>*/}
            {isShareModalOpen && (
                <Modal isOpen={isShareModalOpen}
                       toggle={toggleShareModal} modalClassName='social-share-popup'>
                    <ModalHeader>
                    </ModalHeader>
                    <ModalBody>
                        <div style={{ height: '100px', width: '100%' }}>
                            <div id="pac-test-container">
                                <a href={whatspappLink} target='_blank'>
                                    <img
                                        src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/mhkxmwzwbc/imageFileData/MDg1B?pubver=1'
                                    />
                                </a>
                                {socialShare ? socialShare : [0]}
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                    </ModalFooter>
                </Modal>
            )}
        </>
    );
};

const _renderConfigure = (configure:
                              IBuyboxProductConfigureViewProps): JSX.Element => {

    const { ContainerProps, dropdowns } = configure;
    return <Node
        {...ContainerProps}>{dropdowns.map(_renderConfigureDropdown)}</Node>;
};

const _renderConfigureDropdown = (dropdown:
                                      IBuyboxProductConfigureDropdownViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors,
        select } = dropdown;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>
            {select}
        </Node>
    );
};

const _renderFindInStore = (findInStore: IBuyboxFindInStoreViewProps):
    JSX.Element => {
    const { ContainerProps, storeSelector, heading, description,
        errors, button, modal, productPickupOptionList } = findInStore;

    return (
        <Node {...ContainerProps}>
            {storeSelector}
            {heading}
            {productPickupOptionList}
            {description}
            {errors}
            {button}
            {modal}
        </Node>
    );
};

/**
 * On Change function.
 * @param callbacks -Callbacks.
 * @returns Update quantity.
 */
const onChangeHandler = (callbacks: IBuyboxCallbacks) => (newValue:
                                                              number): boolean => {
    if (callbacks.updateQuantity) {
        return callbacks.updateQuantity(newValue);
    }
    return true;
};

const _renderQuantity = (
    quantityComponent: IBuyboxProductQuantityViewProps,
    callbacks: IBuyboxCallbacks,
    props: IBuyboxProps<IBuyboxData>,
    state: IBuyboxState,
    extentionResources: IBuyboxExtentionResources,
    quantityLimitsMessages: React.ReactNode,
    max: number | undefined,
    telemetryContent?: ITelemetryContent
): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors } =
        quantityComponent;

    const { resources } = props;

    const { quantity } = state;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>

            <IncrementalQuantity
                id='ms-buybox__product-quantity-input'
                max={max}
                currentCount={quantity}
                onChange={onChangeHandler(callbacks)}
                inputQuantityAriaLabel={resources.inputQuantityAriaLabel}

                decrementButtonAriaLabel={extentionResources.decrementButtonAriaLabel}

                incrementButtonAriaLabel={extentionResources.incrementButtonAriaLabel}
                minQuantityText={extentionResources.minQuantityText}
                maxQuantityText={extentionResources.maxQuantityText}
                telemetryContent={telemetryContent}
            />
            {quantityLimitsMessages}
        </Node>
    );
};

const _renderKeyInPrice = (keyInPrice: IBuyboxKeyInPriceViewProps):
    JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, input } = keyInPrice;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>{heading}</Node>
            {input}
        </Node>
    );
};

const _renderShopSimilarItem = (shopSimilarItem:
                                    IBuyboxShopSimilarLookViewProps): JSX.Element => {
    const { ContainerProps, errors, input } = shopSimilarItem;

    return (
        <Node {...ContainerProps}>
            {errors}
            {input}
        </Node>
    );
};

export default BuyboxView;